import directus from '@/plugins/directusSdk'

export default function () {
  return {
    collection: 'member_seating_status',
    action (item) {
      return new Promise((resolve) => {
        directus.getItems('now_options').then(result => {
          item.now = result.data[0]
          resolve(item)
        })
      })
    },

    data: [
      {
        user: 1,
        memo: '例：15時帰社予定',
      },

      {
        user: {
          first_name: '太郎',
          last_name: '山田',
          email: 'taro_yamada@example.com'
        },
        memo: '１〜５日までお休み',
      },

      {
        user: {
          first_name: '直美',
          last_name: '金城',
          email: 'naomi_kanegi@example.com'
        },
        memo: '１〜５日までお休み',
      },

      {
        user: {
          first_name: '夕子',
          last_name: '橋本',
          email: 'yuko_hashimoto@example.com'
        },
        memo: '１〜５日までお休み',
      }
    ]
  }
}
